module.exports = __webpack_public_path__ + "img/easy operation.fdb6733f.jpg";